module.exports = __webpack_public_path__ + "img/ic-ads-acc.e4c84228.svg";